export function initializeSmoothScrolling() {
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const anchorName = link.getAttribute('href')?.slice(1);
      if (!anchorName) return;

      const target = document.querySelector(`[data-anchor="${CSS.escape(anchorName)}"]`);
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
}
